var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFormatImageLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.5V19.1667H21.5V21.5H0.5ZM0.5 16.8333V5.16667H12.1667V16.8333H0.5ZM0.5 2.83333V0.5H21.5V2.83333H0.5ZM2.83333 14.5H9.83333V7.5H2.83333V14.5ZM14.5 16.8333V14.5H21.5V16.8333H14.5ZM14.5 12.1667V9.83333H21.5V12.1667H14.5ZM14.5 7.5V5.16667H21.5V7.5H14.5Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFormatImageLeft);
export default __webpack_public_path__ + "static/media/icon_format_image_left.8484552118dbf625c2ed92ca07e5b63b.svg";
export { ForwardRef as ReactComponent };